import { DateTime } from 'luxon';
import * as yup from 'yup';

export const GenerateReportSchema = yup.object({
  startDate: yup
    .mixed<DateTime>()
    .typeError('Seleccione una fecha')
    .required('Es requerido'),
  endDate: yup
    .mixed<DateTime>()
    .typeError('Seleccione una fecha')
    .required('Es requerido'),
});
